<ng-progress [positionUsing]="'marginLeft'"  [minimum]="0.15"  [maximum]="1" [speed]="500"  [showSpinner]="false"  [direction]="'leftToRightIncreased'" [color]="'#FFBF3F'"  [trickleSpeed]="450"  [thick]="true"  [ease]="'linear'">
</ng-progress>
<app-layout *ngIf="!isEmailWhiteList && !isTermsAndCondition"></app-layout>
<app-email-whitelist *ngIf="isEmailWhiteList"></app-email-whitelist>
<app-terms-and-condition *ngIf="isTermsAndCondition"></app-terms-and-condition>
<!-- <router-outlet></router-outlet> -->

<!--Session Tieout Modal Popup Start -->
<div tabindex="0" aria-label="session Timeout confirmation popup" bsModal #sessionTimeoutModal="bs-modal"
    [config]="{ignoreBackdropClick: true, keyboard:false, backdrop:false}" style="background-color: rgba(0, 0, 0, 0.5);" 
    class="modal fade bs-example modal--center">
    <div class="modal-dialog confirm-dialog">
        <div class="modal-content p-2">
            <div class="modal-header">
                <div>{{'customer-service.Session Inactivity Alert' | translate | translateKey}}</div>
            </div>
            <div class="modal-body">
                {{'customer-service.You will be logged out automatically in' | translate}} <span id="counter">{{idleState | minuteSeconds}}</span>
                {{'customer-service.seconds. Please click the button below to continue working.' | translate}}
            </div>
            <div class="modal-footer">
                <button role="button" aria-label="yes" type="button" (click)="stay()" class="btn btn-primary"
                    id="modal-btn-no">{{'customer-service.Continue Working' | translate | translateKey}}</button>
            </div>
        </div>
    </div>
</div>
<!--Session Tieout Modal Popup End -->

<!-- <div tabindex="0" aria-label="Retirement confirmation popup" bsModal #retirementModal="bs-modal" *ngIf="csp1RetirementNoticeObj"
    [config]="{ignoreBackdropClick: true, keyboard:false, backdrop:false}" style="background-color: rgba(0, 0, 0, 0.5);" 
    class="modal fade bs-example modal--center">
    <div class="modal-dialog confirm-dialog">
        <div class="modal-content p-2">
            <div class="modal-header">
                <div *ngIf="csp1RetirementNoticeObj && csp1RetirementNoticeObj.title">{{csp1RetirementNoticeObj.title}}</div>
            </div>
            <div class="modal-body">
                <span><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></span>  <span>{{csp1RetirementNoticeObj.content}}</span> <span><a class="link--light" href="{{csp1RetirementNoticeObj.link}}" target="_blank"
                    tabindex="0">{{'checkout.Click here' | translate | translateKey}}</a></span>
            </div>
            <div class="modal-footer">
                <button role="button" aria-label="yes" type="button" (click)="close()" class="btn btn-primary"
                    id="modal-btn-no">{{'customer-service.CLOSE' | translate | translateKey}}</button>
            </div>
        </div>
    </div>
</div> -->

<div div tabindex="0" aria-label="Retirement confirmation popup" bsModal #retirementModal="bs-modal"
    *ngIf="csp1RetirementNoticeObj" [config]="{ignoreBackdropClick: true, keyboard:false, backdrop:false}"
    style="background-color: rgba(0, 0, 0, 0.5);" class="modal fade bs-example modal--center">
    <div class="modal-dialog confirm-dialog retirement-modal">
        <div class="modal-content p-2">
            <div class="modal-header">
                <div class="notice-title" *ngIf="csp1RetirementNoticeObj && csp1RetirementNoticeObj.title">{{csp1RetirementNoticeObj.title}}</div>
            </div> 
            <!-- Transition Description -->
            <div class="modal-body">
                <!-- Retirement Notice -->
                <div class="retirement-notice" *ngIf="csp1RetirementNoticeObj && csp1RetirementNoticeObj.noticeDescription">
                    <div class="retirement-notice-content" [innerHTML]="getNoticeDescription()"></div>
                </div>
                <div class="notice-content-pad mb-0">
                    <p *ngIf="csp1RetirementNoticeObj && csp1RetirementNoticeObj.transitionDescription">{{
                        csp1RetirementNoticeObj.transitionDescription }}</p>
                </div>
                <!-- How To Switch -->
                <div class="how-to-switch notice-content-pad">
                    <div class="how-to-switch-title">
                        <span class="info-icon">
                            <i class="fa fa-info" aria-hidden="true"></i>
                        </span>
                        <strong *ngIf="csp1RetirementNoticeObj && csp1RetirementNoticeObj.howToSwitchTitle"> {{
                            csp1RetirementNoticeObj.howToSwitchTitle }} </strong>
                    </div>
                    <ul
                        *ngIf="csp1RetirementNoticeObj && csp1RetirementNoticeObj.howToSwitchSteps && csp1RetirementNoticeObj.howToSwitchSteps.length">
                        <li *ngFor="let step of csp1RetirementNoticeObj.howToSwitchSteps">
                            {{ step }}
                        </li>
                    </ul>
                </div>
                <!-- Footer Message -->
                <p *ngIf="csp1RetirementNoticeObj && csp1RetirementNoticeObj.footerMessage" class="footer-message">
                    <em> {{ csp1RetirementNoticeObj.footerMessage }} </em>
                </p>
            </div>
            <!-- Footer -->
            <div class="modal-footer retirement-footer"> 
                <button type="button" class="btn blue-button" (click)="openCsp2()"> {{ csp1RetirementNoticeObj.navigationLabel }}</button>
                <button  type="button" class="btn grey-button" (click)="close()">  {{ 'customer-service.CLOSE' | translate | translateKey }} </button>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/app.component.html